import React from 'react';
import './Category.css';

import { Link } from 'react-router-dom';
import { renderIcon } from '../../utils';

const Category = (props) => {

  // Destructuring props
  const { index, category, count, image } = props;

  // Short info about each category
  const categoryInfo = {
    "HTML Templates": "Fully responsive and easy to customize",
    "React Templates": "Modern components with hooks & routing",
    "landing pages": "High-converting designs for marketing",
  };

  // Get info or use default
  const info = categoryInfo[category] || `${count}+ high-quality designs available`;

  return (

    <div className={`category-item category-${index}`} key={index}>

      <div className='content'>

        <div className='icon'>{renderIcon(category)}</div>

        {/* Link to the filtered products page */}
        <Link
          to={{
            pathname: '/Shop/category/' + category,
          }}
          state={{ category, count, image }}
        >
          <h3>{category}</h3>
        </Link>

        {/* Short info about category - REPLACED LINE */}
        <p className="category-info">{info}</p>

        <h4>{count} Templates</h4>

        {/* Category Image */}
        <img src={image} alt={category} />

      </div>

    </div>

  );
};

export default Category;